import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29,24H3a1,1,0,0,0,0,2H29a1,1,0,0,0,0-2Z"/><path d="M6.707,20.29a1.008,1.008,0,0,1,0,1.42,1.014,1.014,0,0,1-1.42,0l-.79-.8-.79.8a1.014,1.014,0,0,1-1.42,0,1.008,1.008,0,0,1,0-1.42l.8-.79-.8-.79a1,1,0,0,1,1.42-1.42l.79.8.79-.8a1,1,0,0,1,1.42,1.42l-.8.79Z"/><path d="M18.967,20.74l-3.75-14a1,1,0,0,0-.97-.74h-.5a1,1,0,0,0-.97.74l-3.75,14a1,1,0,0,0,1.94.52l.88-3.29A.8.8,0,0,0,12,18h4a.8.8,0,0,0,.15-.03l.88,3.29A1,1,0,0,0,18,22a1.222,1.222,0,0,0,.26-.03A1.017,1.017,0,0,0,18.967,20.74ZM12.367,16,14,9.93,15.627,16Z"/><path d="M29.967,20.74l-3.75-14a1,1,0,0,0-.97-.74h-.5a1,1,0,0,0-.97.74l-3.75,14a1,1,0,0,0,1.94.52l.88-3.29A.8.8,0,0,0,23,18h4a.8.8,0,0,0,.15-.03l.88,3.29A1,1,0,0,0,29,22a1.222,1.222,0,0,0,.26-.03A1.017,1.017,0,0,0,29.967,20.74ZM23.367,16,25,9.93,26.627,16Z"/>';
export var InitialsSVG = function InitialsSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
InitialsSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(InitialsSVG);